<div class="container">
  <app-main-menu></app-main-menu>
  <div class="main-content-container">
    <div class="fixed-header">
      <div class="user-info">
        <div class="user-avatar">
          <app-user-avatar [initials]="initials" [username]="username" [name]="name" [role]="role" (logoutRequest)="onLogout()" class="avatar-component"></app-user-avatar>
        </div>
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>
